/**
 * Stripe Checkout URLs must be opened as a normal HTTPS URL.
 * JSON/API layers sometimes leave escaped slashes (`https:\/\/...`); copying from raw JSON can break navigation.
 *
 * @param {unknown} raw
 * @returns {string|null}
 */
export function sanitizeStripeCheckoutUrl(raw) {
  if (raw == null) return null;
  let s = typeof raw === "string" ? raw.trim() : String(raw).trim();
  if (!s) return null;
  // JSON-escaped slashes from stringified responses
  s = s.replace(/\\\//g, "/");
  // Strip wrapping quotes if someone double-encoded
  if ((s.startsWith('"') && s.endsWith('"')) || (s.startsWith("'") && s.endsWith("'"))) {
    s = s.slice(1, -1).trim();
  }
  if (!/^https?:\/\//i.test(s)) return null;
  try {
    const u = new URL(s);
    const host = u.hostname.toLowerCase();
    if (host !== "checkout.stripe.com" && host !== "buy.stripe.com") {
      console.warn("[stripe] Unexpected checkout host:", host);
    }
    return u.toString();
  } catch {
    return null;
  }
}
